"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeTaggingString = exports.sendTagging = exports.sendCustomTaggingWithParams = exports.sendPriorityTagging = exports.detectCorrectButtonType = exports.sendManagementTagging = exports.sendButtonTagging = exports.push2DataLayer = exports.addEvent2GTM = exports.taggingButtonTypes = exports.PROD = exports.DEV = void 0;

var _gerenciatdUtils = require("@bit/gerenciatd.utils.html-utils");

var DEV = 'development';
exports.DEV = DEV;
var PROD = 'production';
exports.PROD = PROD;

var howAppIsRunning = function howAppIsRunning() {
  var NODE_ENV = process.env.NODE_ENV;
  return NODE_ENV;
};

var taggingButtonTypes = {
  MENU: 'menu',
  BUTTON: 'boton',
  LINK: 'enlace',
  TAB: 'tab'
};
/* this is used by pageviewVirtual */

exports.taggingButtonTypes = taggingButtonTypes;

var addEvent2GTM = function addEvent2GTM(events) {
  if (howAppIsRunning() !== DEV) {
    var _window = window,
        dataLayerGTM = _window.dataLayerGTM;
    var numberOfEvents = dataLayerGTM.length;
    var lastEvent = dataLayerGTM[numberOfEvents - 1];
    var APpageName = events.APpageName,
        APpage = events.APpage; // push only if the last event: pageviewVirtual is not the same

    if (!(APpageName && APpageName === lastEvent.APpageName)) {
      window.dataLayerGTM.push(events);
    }
  }
};

exports.addEvent2GTM = addEvent2GTM;

var push2DataLayer = function push2DataLayer() {
  var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var GAcategory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var GAaction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var GAlabel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

  if (howAppIsRunning() !== DEV) {
    var _window2 = window,
        dataLayerGTM = _window2.dataLayerGTM;
    var numberOfEvents = dataLayerGTM.length;
    var eventCounter = 0;
    var pushConfirmation = true;

    for (var dlindex = numberOfEvents - 1; dlindex >= 0 && eventCounter < 5; dlindex -= 1) {
      var currentEvent = dataLayerGTM[dlindex];

      if (GAcategory === currentEvent.GAcategory && GAaction === currentEvent.GAaction) {
        pushConfirmation = false;
        break;
      }

      eventCounter += 1;
    } // only push one time


    if (pushConfirmation) {
      dataLayerGTM.push({
        event: event,
        GAcategory: GAcategory,
        GAaction: GAaction,
        GAlabel: GAlabel
      });
    }
  }
};

exports.push2DataLayer = push2DataLayer;

var sendButtonTagging = function sendButtonTagging(eventType, value) {
  if (howAppIsRunning() !== DEV) {
    var _window3 = window,
        dataLayerGTM = _window3.dataLayerGTM;

    if (dataLayerGTM) {
      dataLayerGTM.push({
        event: 'boton',
        APeventAction: eventType,
        APeventLabel: value
      });
    }
  }
};

exports.sendButtonTagging = sendButtonTagging;

var sendManagementTagging = function sendManagementTagging(actionValue, labelValue) {
  if (howAppIsRunning() !== DEV) {
    var _window4 = window,
        dataLayerGTM = _window4.dataLayerGTM;
    dataLayerGTM.push({
      GAcategory: 'eServicing',
      GAaction: actionValue,
      GAlabel: labelValue,
      event: 'asyncGTM'
    });
  }
};

exports.sendManagementTagging = sendManagementTagging;

var detectCorrectButtonType = function detectCorrectButtonType(typeToTest) {
  var correctType = false;
  Object.keys(taggingButtonTypes).forEach(function (typeName) {
    if (typeToTest === taggingButtonTypes[typeName]) {
      correctType = true;
    }
  });
  return correctType;
};

exports.detectCorrectButtonType = detectCorrectButtonType;

var sendPriorityTagging = function sendPriorityTagging(clientePriority) {
  var _window5 = window,
      dataLayerGTM = _window5.dataLayerGTM;

  if (dataLayerGTM) {
    dataLayerGTM.push({
      clientePriority: clientePriority
    });
  }
};

exports.sendPriorityTagging = sendPriorityTagging;

var sendCustomTaggingWithParams = function sendCustomTaggingWithParams(gtmStructure, params) {
  var event = gtmStructure.event,
      GAcategory = gtmStructure.GAcategory,
      GAlabel = gtmStructure.GAlabel;
  var GAaction = gtmStructure.GAaction;
  params.forEach(function (param) {
    GAaction = GAaction.replace('%?%', param);
  });
  push2DataLayer(event, GAcategory, GAaction, GAlabel);
};

exports.sendCustomTaggingWithParams = sendCustomTaggingWithParams;

var sendTagging = function sendTagging(taggingType, id, managementValue) {
  if (howAppIsRunning() !== DEV) {
    if (!managementValue && taggingType && id && detectCorrectButtonType(taggingType)) {
      sendButtonTagging(taggingType, id);
    }

    if (managementValue && id) {
      sendManagementTagging(managementValue, id);
    }
  }
};

exports.sendTagging = sendTagging;

var normalizeTaggingString = function normalizeTaggingString(str) {
  var strReturn;
  strReturn = str.toLowerCase();
  strReturn = strReturn.replace(/ /g, '-');
  strReturn = (0, _gerenciatdUtils.normalizeAccent)(strReturn);
  strReturn = strReturn.replace(/[^a-z0-9-]/g, '');
  return strReturn;
};

exports.normalizeTaggingString = normalizeTaggingString;

//# sourceMappingURL=index.js.map